import React from 'react';
import PropTypes from 'prop-types';

const Error = (props) => {
  let id = 0;
  const errors = props.message.split('\n').map((error) =>
    (<li key={id++}>{error}</li>),
  );

  return <ul className="error">{errors}</ul>
};

Error.defaultProps = {
  message: 'unknown ERROR',
};

// propTypes
Error.propTypes = {
  message: PropTypes.string.isRequired,
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error/Error.js